import { gql } from "graphql-request";

export const VALIDATE_EMAIL_QUERY = gql`query validateEmail($selectFields: String!, $inFilters:AWSJSON!, $pageLimit:Int, $pageOffset: Int) {
  listUsersDynamicFilter(input:{selectFields: $selectFields, inFilters: $inFilters, pageLimit: $pageLimit, pageOffset:$pageOffset}){
    message
    statusCode
  }
}`;